// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "airline-mMNeY";
var _3 = "airline__number-1qyjQ";
var _4 = "airline__name-3qSAw";
var _5 = "aircraft__name_active-2UJnb";
export { _1 as "__esModule", _2 as "airline", _3 as "airline__number", _4 as "airline__name", _5 as "aircraft__name_active" }
export default { "__esModule": _1, "airline": _2, "airline__number": _3, "airline__name": _4, "aircraft__name_active": _5 }
